"use client";

import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
import Vector from "../../assets/LandingPage/Vector.png";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { HiOutlineDocumentText } from "react-icons/hi";

gsap.registerPlugin(ScrollTrigger, Draggable);

export const features = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M20 35C15.8056 35 12.2569 34.3542 9.35417 33.0625C6.45139 31.7708 5 30.1944 5 28.3333V11.6667C5 9.83333 6.46528 8.26389 9.39583 6.95833C12.3264 5.65278 15.8611 5 20 5C24.1389 5 27.6736 5.65278 30.6042 6.95833C33.5347 8.26389 35 9.83333 35 11.6667V28.3333C35 30.1944 33.5486 31.7708 30.6458 33.0625C27.7431 34.3542 24.1944 35 20 35ZM20 15.0417C22.4722 15.0417 24.9583 14.6875 27.4583 13.9792C29.9583 13.2708 31.3611 12.5139 31.6667 11.7083C31.3611 10.9028 29.9653 10.1389 27.4792 9.41667C24.9931 8.69444 22.5 8.33333 20 8.33333C17.4722 8.33333 14.9931 8.6875 12.5625 9.39583C10.1319 10.1042 8.72222 10.875 8.33333 11.7083C8.72222 12.5417 10.1319 13.3056 12.5625 14C14.9931 14.6944 17.4722 15.0417 20 15.0417ZM20 23.3333C21.1667 23.3333 22.2917 23.2778 23.375 23.1667C24.4583 23.0556 25.4931 22.8958 26.4792 22.6875C27.4653 22.4792 28.3958 22.2222 29.2708 21.9167C30.1458 21.6111 30.9444 21.2639 31.6667 20.875V15.875C30.9444 16.2639 30.1458 16.6111 29.2708 16.9167C28.3958 17.2222 27.4653 17.4792 26.4792 17.6875C25.4931 17.8958 24.4583 18.0556 23.375 18.1667C22.2917 18.2778 21.1667 18.3333 20 18.3333C18.8333 18.3333 17.6944 18.2778 16.5833 18.1667C15.4722 18.0556 14.4236 17.8958 13.4375 17.6875C12.4514 17.4792 11.5278 17.2222 10.6667 16.9167C9.80556 16.6111 9.02778 16.2639 8.33333 15.875V20.875C9.02778 21.2639 9.80556 21.6111 10.6667 21.9167C11.5278 22.2222 12.4514 22.4792 13.4375 22.6875C14.4236 22.8958 15.4722 23.0556 16.5833 23.1667C17.6944 23.2778 18.8333 23.3333 20 23.3333ZM20 31.6667C21.2778 31.6667 22.5764 31.5694 23.8958 31.375C25.2153 31.1806 26.4306 30.9236 27.5417 30.6042C28.6528 30.2847 29.5833 29.9236 30.3333 29.5208C31.0833 29.1181 31.5278 28.7083 31.6667 28.2917V24.2083C30.9444 24.5972 30.1458 24.9444 29.2708 25.25C28.3958 25.5556 27.4653 25.8125 26.4792 26.0208C25.4931 26.2292 24.4583 26.3889 23.375 26.5C22.2917 26.6111 21.1667 26.6667 20 26.6667C18.8333 26.6667 17.6944 26.6111 16.5833 26.5C15.4722 26.3889 14.4236 26.2292 13.4375 26.0208C12.4514 25.8125 11.5278 25.5556 10.6667 25.25C9.80556 24.9444 9.02778 24.5972 8.33333 24.2083V28.3333C8.47222 28.75 8.90972 29.1528 9.64583 29.5417C10.3819 29.9306 11.3056 30.2847 12.4167 30.6042C13.5278 30.9236 14.75 31.1806 16.0833 31.375C17.4167 31.5694 18.7222 31.6667 20 31.6667Z"
          fill="#0088FF"
        />
      </svg>
    ),
    title: "Supplier Marketplace",
    description:
      "Access to 100k+ pre-screened supplier records with comprehensive verification and scoring.",
    badge: "100k+ Suppliers",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M1.66699 28.6665C1.66699 27.7221 1.91005 26.854 2.39616 26.0623C2.88227 25.2707 3.5281 24.6665 4.33366 24.2498C6.05588 23.3887 7.80588 22.7429 9.58366 22.3123C11.3614 21.8818 13.167 21.6665 15.0003 21.6665C16.8337 21.6665 18.6392 21.8818 20.417 22.3123C22.1948 22.7429 23.9448 23.3887 25.667 24.2498C26.4725 24.6665 27.1184 25.2707 27.6045 26.0623C28.0906 26.854 28.3337 27.7221 28.3337 28.6665V29.9998C28.3337 30.9165 28.0073 31.7012 27.3545 32.354C26.7017 33.0068 25.917 33.3332 25.0003 33.3332H5.00033C4.08366 33.3332 3.29894 33.0068 2.64616 32.354C1.99338 31.7012 1.66699 30.9165 1.66699 29.9998V28.6665ZM35.0003 33.3332H30.7503C31.0559 32.8332 31.285 32.2984 31.4378 31.729C31.5906 31.1596 31.667 30.5832 31.667 29.9998V28.3332C31.667 27.1109 31.3267 25.9373 30.6462 24.8123C29.9656 23.6873 29.0003 22.7221 27.7503 21.9165C29.167 22.0832 30.5003 22.3679 31.7503 22.7707C33.0003 23.1734 34.167 23.6665 35.2503 24.2498C36.2503 24.8054 37.0142 25.4234 37.542 26.104C38.0698 26.7846 38.3337 27.5276 38.3337 28.3332V29.9998C38.3337 30.9165 38.0073 31.7012 37.3545 32.354C36.7017 33.0068 35.917 33.3332 35.0003 33.3332ZM15.0003 19.9998C13.167 19.9998 11.5975 19.3471 10.292 18.0415C8.98644 16.7359 8.33366 15.1665 8.33366 13.3332C8.33366 11.4998 8.98644 9.93039 10.292 8.62484C11.5975 7.31928 13.167 6.6665 15.0003 6.6665C16.8337 6.6665 18.4031 7.31928 19.7087 8.62484C21.0142 9.93039 21.667 11.4998 21.667 13.3332C21.667 15.1665 21.0142 16.7359 19.7087 18.0415C18.4031 19.3471 16.8337 19.9998 15.0003 19.9998ZM31.667 13.3332C31.667 15.1665 31.0142 16.7359 29.7087 18.0415C28.4031 19.3471 26.8337 19.9998 25.0003 19.9998C24.6948 19.9998 24.3059 19.9651 23.8337 19.8957C23.3614 19.8262 22.9725 19.7498 22.667 19.6665C23.417 18.7776 23.9934 17.7915 24.3962 16.7082C24.7989 15.6248 25.0003 14.4998 25.0003 13.3332C25.0003 12.1665 24.7989 11.0415 24.3962 9.95817C23.9934 8.87484 23.417 7.88873 22.667 6.99984C23.0559 6.86095 23.4448 6.77067 23.8337 6.729C24.2225 6.68734 24.6114 6.6665 25.0003 6.6665C26.8337 6.6665 28.4031 7.31928 29.7087 8.62484C31.0142 9.93039 31.667 11.4998 31.667 13.3332ZM5.00033 29.9998H25.0003V28.6665C25.0003 28.3609 24.9239 28.0832 24.7712 27.8332C24.6184 27.5832 24.417 27.3887 24.167 27.2498C22.667 26.4998 21.1531 25.9373 19.6253 25.5623C18.0975 25.1873 16.5559 24.9998 15.0003 24.9998C13.4448 24.9998 11.9031 25.1873 10.3753 25.5623C8.84755 25.9373 7.33366 26.4998 5.83366 27.2498C5.58366 27.3887 5.38227 27.5832 5.22949 27.8332C5.07671 28.0832 5.00033 28.3609 5.00033 28.6665V29.9998ZM15.0003 16.6665C15.917 16.6665 16.7017 16.3401 17.3545 15.6873C18.0073 15.0346 18.3337 14.2498 18.3337 13.3332C18.3337 12.4165 18.0073 11.6318 17.3545 10.979C16.7017 10.3262 15.917 9.99984 15.0003 9.99984C14.0837 9.99984 13.2989 10.3262 12.6462 10.979C11.9934 11.6318 11.667 12.4165 11.667 13.3332C11.667 14.2498 11.9934 15.0346 12.6462 15.6873C13.2989 16.3401 14.0837 16.6665 15.0003 16.6665Z"
          fill="#0088FF"
        />
      </svg>
    ),
    title: "Collaboration Hub",
    description:
      "Cross-department communication tools with role-based access and real-time updates.",
    badge: "Team Tools",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M17.583 30.3332L26.208 19.9999H19.5413L20.7496 10.5416L13.0413 21.6666H18.833L17.583 30.3332ZM14.9996 24.9999H9.83296C9.16629 24.9999 8.67323 24.7013 8.35379 24.1041C8.03435 23.5068 8.06907 22.9305 8.45796 22.3749L20.9163 4.45823C21.1941 4.06935 21.5552 3.79851 21.9996 3.64573C22.4441 3.49296 22.9024 3.4999 23.3746 3.66657C23.8468 3.83323 24.1941 4.1249 24.4163 4.54157C24.6385 4.95823 24.7218 5.40268 24.6663 5.8749L23.333 16.6666H29.7913C30.5135 16.6666 31.0205 16.986 31.3121 17.6249C31.6038 18.2638 31.5135 18.861 31.0413 19.4166L17.333 35.8332C17.0274 36.1943 16.6524 36.4305 16.208 36.5416C15.7635 36.6527 15.333 36.611 14.9163 36.4166C14.4996 36.2221 14.1732 35.9235 13.9371 35.5207C13.701 35.118 13.6107 34.6805 13.6663 34.2082L14.9996 24.9999Z"
          fill="#0088FF"
        />
      </svg>
    ),
    title: "Autonomous Sourcing Engine",
    description:
      "AI-powered supplier matching with proprietary algorithms that find the perfect vendors for your needs.",
    badge: "AI-Powered",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M4.99967 35C4.52745 35 4.13162 34.8403 3.81217 34.5208C3.49273 34.2014 3.33301 33.8056 3.33301 33.3333C3.33301 32.8611 3.49273 32.4653 3.81217 32.1458C4.13162 31.8264 4.52745 31.6667 4.99967 31.6667H34.9997C35.4719 31.6667 35.8677 31.8264 36.1872 32.1458C36.5066 32.4653 36.6663 32.8611 36.6663 33.3333C36.6663 33.8056 36.5066 34.2014 36.1872 34.5208C35.8677 34.8403 35.4719 35 34.9997 35H4.99967ZM7.49967 30C6.80523 30 6.21495 29.7569 5.72884 29.2708C5.24273 28.7847 4.99967 28.1944 4.99967 27.5V20.8333C4.99967 20.1389 5.24273 19.5486 5.72884 19.0625C6.21495 18.5764 6.80523 18.3333 7.49967 18.3333C8.19412 18.3333 8.7844 18.5764 9.27051 19.0625C9.75662 19.5486 9.99967 20.1389 9.99967 20.8333V27.5C9.99967 28.1944 9.75662 28.7847 9.27051 29.2708C8.7844 29.7569 8.19412 30 7.49967 30ZM15.833 30C15.1386 30 14.5483 29.7569 14.0622 29.2708C13.5761 28.7847 13.333 28.1944 13.333 27.5V12.5C13.333 11.8056 13.5761 11.2153 14.0622 10.7292C14.5483 10.2431 15.1386 10 15.833 10C16.5275 10 17.1177 10.2431 17.6038 10.7292C18.09 11.2153 18.333 11.8056 18.333 12.5V27.5C18.333 28.1944 18.09 28.7847 17.6038 29.2708C17.1177 29.7569 16.5275 30 15.833 30ZM24.1663 30C23.4719 30 22.8816 29.7569 22.3955 29.2708C21.9094 28.7847 21.6663 28.1944 21.6663 27.5V17.5C21.6663 16.8056 21.9094 16.2153 22.3955 15.7292C22.8816 15.2431 23.4719 15 24.1663 15C24.8608 15 25.4511 15.2431 25.9372 15.7292C26.4233 16.2153 26.6663 16.8056 26.6663 17.5V27.5C26.6663 28.1944 26.4233 28.7847 25.9372 29.2708C25.4511 29.7569 24.8608 30 24.1663 30ZM32.4997 30C31.8052 30 31.215 29.7569 30.7288 29.2708C30.2427 28.7847 29.9997 28.1944 29.9997 27.5V7.5C29.9997 6.80556 30.2427 6.21528 30.7288 5.72917C31.215 5.24306 31.8052 5 32.4997 5C33.1941 5 33.7844 5.24306 34.2705 5.72917C34.7566 6.21528 34.9997 6.80556 34.9997 7.5V27.5C34.9997 28.1944 34.7566 28.7847 34.2705 29.2708C33.7844 29.7569 33.1941 30 32.4997 30Z"
          fill="#0088FF"
        />
      </svg>
    ),
    title: "Budget & Spend Intelligence",
    description:
      "Real-time spend analytics with predictive insights and budget optimization recommendations.",
    badge: "Analytics",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M18.0421 36.6668C17.2921 36.6668 16.6463 36.4168 16.1046 35.9168C15.563 35.4168 15.2366 34.8057 15.1255 34.0835L14.7505 31.3335C14.3893 31.1946 14.0491 31.0279 13.7296 30.8335C13.4102 30.639 13.0977 30.4307 12.7921 30.2085L10.2088 31.2918C9.51434 31.5974 8.8199 31.6252 8.12546 31.3752C7.43101 31.1252 6.88934 30.6807 6.50046 30.0418L4.54212 26.6252C4.15323 25.9863 4.04212 25.3057 4.20879 24.5835C4.37546 23.8613 4.75046 23.264 5.33379 22.7918L7.54212 21.1252C7.51434 20.9307 7.50046 20.7432 7.50046 20.5627V19.4377C7.50046 19.2571 7.51434 19.0696 7.54212 18.8752L5.33379 17.2085C4.75046 16.7363 4.37546 16.1391 4.20879 15.4168C4.04212 14.6946 4.15323 14.0141 4.54212 13.3752L6.50046 9.9585C6.88934 9.31961 7.43101 8.87516 8.12546 8.62516C8.8199 8.37516 9.51434 8.40294 10.2088 8.7085L12.7921 9.79183C13.0977 9.56961 13.4171 9.36127 13.7505 9.16683C14.0838 8.97238 14.4171 8.80572 14.7505 8.66683L15.1255 5.91683C15.2366 5.19461 15.563 4.5835 16.1046 4.0835C16.6463 3.5835 17.2921 3.3335 18.0421 3.3335H21.9588C22.7088 3.3335 23.3546 3.5835 23.8963 4.0835C24.438 4.5835 24.7643 5.19461 24.8755 5.91683L25.2505 8.66683C25.6116 8.80572 25.9518 8.97238 26.2713 9.16683C26.5907 9.36127 26.9032 9.56961 27.2088 9.79183L29.7921 8.7085C30.4866 8.40294 31.181 8.37516 31.8755 8.62516C32.5699 8.87516 33.1116 9.31961 33.5005 9.9585L35.4588 13.3752C35.8477 14.0141 35.9588 14.6946 35.7921 15.4168C35.6255 16.1391 35.2505 16.7363 34.6671 17.2085L32.4588 18.8752C32.4866 19.0696 32.5005 19.2571 32.5005 19.4377V20.5627C32.5005 20.7432 32.4727 20.9307 32.4171 21.1252L34.6255 22.7918C35.2088 23.264 35.5838 23.8613 35.7505 24.5835C35.9171 25.3057 35.806 25.9863 35.4171 26.6252L33.4171 30.0418C33.0282 30.6807 32.4866 31.1252 31.7921 31.3752C31.0977 31.6252 30.4032 31.5974 29.7088 31.2918L27.2088 30.2085C26.9032 30.4307 26.5838 30.639 26.2505 30.8335C25.9171 31.0279 25.5838 31.1946 25.2505 31.3335L24.8755 34.0835C24.7643 34.8057 24.438 35.4168 23.8963 35.9168C23.3546 36.4168 22.7088 36.6668 21.9588 36.6668H18.0421ZM18.3338 33.3335H21.6255L22.2088 28.9168C23.0699 28.6946 23.8685 28.3682 24.6046 27.9377C25.3407 27.5071 26.0143 26.9863 26.6255 26.3752L30.7505 28.0835L32.3755 25.2502L28.7921 22.5418C28.931 22.1529 29.0282 21.7432 29.0838 21.3127C29.1393 20.8821 29.1671 20.4446 29.1671 20.0002C29.1671 19.5557 29.1393 19.1182 29.0838 18.6877C29.0282 18.2571 28.931 17.8474 28.7921 17.4585L32.3755 14.7502L30.7505 11.9168L26.6255 13.6668C26.0143 13.0279 25.3407 12.4932 24.6046 12.0627C23.8685 11.6321 23.0699 11.3057 22.2088 11.0835L21.6671 6.66683H18.3755L17.7921 11.0835C16.931 11.3057 16.1324 11.6321 15.3963 12.0627C14.6602 12.4932 13.9866 13.0141 13.3755 13.6252L9.25046 11.9168L7.62546 14.7502L11.2088 17.4168C11.0699 17.8335 10.9727 18.2502 10.9171 18.6668C10.8616 19.0835 10.8338 19.5279 10.8338 20.0002C10.8338 20.4446 10.8616 20.8752 10.9171 21.2918C10.9727 21.7085 11.0699 22.1252 11.2088 22.5418L7.62546 25.2502L9.25046 28.0835L13.3755 26.3335C13.9866 26.9724 14.6602 27.5071 15.3963 27.9377C16.1324 28.3682 16.931 28.6946 17.7921 28.9168L18.3338 33.3335ZM20.0838 25.8335C21.6949 25.8335 23.0699 25.264 24.2088 24.1252C25.3477 22.9863 25.9171 21.6113 25.9171 20.0002C25.9171 18.3891 25.3477 17.0141 24.2088 15.8752C23.0699 14.7363 21.6949 14.1668 20.0838 14.1668C18.4449 14.1668 17.063 14.7363 15.938 15.8752C14.813 17.0141 14.2505 18.3891 14.2505 20.0002C14.2505 21.6113 14.813 22.9863 15.938 24.1252C17.063 25.264 18.4449 25.8335 20.0838 25.8335Z"
          fill="#0088FF"
        />
      </svg>
    ),
    title: "Workflow Automation",
    description:
      "Streamline approval processes with intelligent routing and automated notifications.",
    badge: "Automation",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M15.0003 21.6668H25.0003C25.4725 21.6668 25.8684 21.5071 26.1878 21.1877C26.5073 20.8682 26.667 20.4724 26.667 20.0002C26.667 19.5279 26.5073 19.1321 26.1878 18.8127C25.8684 18.4932 25.4725 18.3335 25.0003 18.3335H15.0003C14.5281 18.3335 14.1323 18.4932 13.8128 18.8127C13.4934 19.1321 13.3337 19.5279 13.3337 20.0002C13.3337 20.4724 13.4934 20.8682 13.8128 21.1877C14.1323 21.5071 14.5281 21.6668 15.0003 21.6668ZM15.0003 26.6668H25.0003C25.4725 26.6668 25.8684 26.5071 26.1878 26.1877C26.5073 25.8682 26.667 25.4724 26.667 25.0002C26.667 24.5279 26.5073 24.1321 26.1878 23.8127C25.8684 23.4932 25.4725 23.3335 25.0003 23.3335H15.0003C14.5281 23.3335 14.1323 23.4932 13.8128 23.8127C13.4934 24.1321 13.3337 24.5279 13.3337 25.0002C13.3337 25.4724 13.4934 25.8682 13.8128 26.1877C14.1323 26.5071 14.5281 26.6668 15.0003 26.6668ZM15.0003 31.6668H20.0003C20.4725 31.6668 20.8684 31.5071 21.1878 31.1877C21.5073 30.8682 21.667 30.4724 21.667 30.0002C21.667 29.5279 21.5073 29.1321 21.1878 28.8127C20.8684 28.4932 20.4725 28.3335 20.0003 28.3335H15.0003C14.5281 28.3335 14.1323 28.4932 13.8128 28.8127C13.4934 29.1321 13.3337 29.5279 13.3337 30.0002C13.3337 30.4724 13.4934 30.8682 13.8128 31.1877C14.1323 31.5071 14.5281 31.6668 15.0003 31.6668ZM10.0003 36.6668C9.08366 36.6668 8.29894 36.3404 7.64616 35.6877C6.99338 35.0349 6.66699 34.2502 6.66699 33.3335V6.66683C6.66699 5.75016 6.99338 4.96544 7.64616 4.31266C8.29894 3.65988 9.08366 3.3335 10.0003 3.3335H21.9587C22.4031 3.3335 22.8267 3.41683 23.2295 3.5835C23.6323 3.75016 23.9864 3.98627 24.292 4.29183L32.3753 12.3752C32.6809 12.6807 32.917 13.0349 33.0837 13.4377C33.2503 13.8404 33.3337 14.2641 33.3337 14.7085V33.3335C33.3337 34.2502 33.0073 35.0349 32.3545 35.6877C31.7017 36.3404 30.917 36.6668 30.0003 36.6668H10.0003ZM30.0003 15.0002H24.167C23.4725 15.0002 22.8823 14.7571 22.3962 14.271C21.91 13.7849 21.667 13.1946 21.667 12.5002V6.66683H10.0003V33.3335H30.0003V15.0002Z"
          fill="#0088FF"
        />
      </svg>
    ),
    title: "RFP & Intake Tools",
    description:
      "Intelligent RFP creation and supplier response management with automated scoring.",
    badge: "Smart RFPs",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M20.0003 36.5002C19.8059 36.5002 19.6253 36.4863 19.4587 36.4585C19.292 36.4307 19.1253 36.3891 18.9587 36.3335C15.2087 35.0835 12.2225 32.771 10.0003 29.396C7.7781 26.021 6.66699 22.3891 6.66699 18.5002V10.6252C6.66699 9.93072 6.86838 9.30572 7.27116 8.75016C7.67394 8.19461 8.19477 7.79183 8.83366 7.54183L18.8337 3.79183C19.2225 3.65294 19.6114 3.5835 20.0003 3.5835C20.3892 3.5835 20.7781 3.65294 21.167 3.79183L31.167 7.54183C31.8059 7.79183 32.3267 8.19461 32.7295 8.75016C33.1323 9.30572 33.3337 9.93072 33.3337 10.6252V18.5002C33.3337 22.3891 32.2225 26.021 30.0003 29.396C27.7781 32.771 24.792 35.0835 21.042 36.3335C20.8753 36.3891 20.7087 36.4307 20.542 36.4585C20.3753 36.4863 20.1948 36.5002 20.0003 36.5002ZM20.0003 33.1668C22.8892 32.2502 25.2781 30.4168 27.167 27.6668C29.0559 24.9168 30.0003 21.8613 30.0003 18.5002V10.6252L20.0003 6.87516L10.0003 10.6252V18.5002C10.0003 21.8613 10.9448 24.9168 12.8337 27.6668C14.7225 30.4168 17.1114 32.2502 20.0003 33.1668Z"
          fill="#0088FF"
        />
      </svg>
    ),
    title: "Compliance & Audit",
    description:
      "Built-in compliance tracking with audit-ready logs and regulatory reporting.",
    badge: "Compliance",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M11.6663 28.3332C9.36079 28.3332 7.39551 27.5207 5.77051 25.8957C4.14551 24.2707 3.33301 22.3054 3.33301 19.9998C3.33301 17.6943 4.14551 15.729 5.77051 14.104C7.39551 12.479 9.36079 11.6665 11.6663 11.6665H16.6663C17.1386 11.6665 17.5344 11.8262 17.8538 12.1457C18.1733 12.4651 18.333 12.8609 18.333 13.3332C18.333 13.8054 18.1733 14.2012 17.8538 14.5207C17.5344 14.8401 17.1386 14.9998 16.6663 14.9998H11.6663C10.2775 14.9998 9.0969 15.4859 8.12467 16.4582C7.15245 17.4304 6.66634 18.6109 6.66634 19.9998C6.66634 21.3887 7.15245 22.5693 8.12467 23.5415C9.0969 24.5137 10.2775 24.9998 11.6663 24.9998H16.6663C17.1386 24.9998 17.5344 25.1596 17.8538 25.479C18.1733 25.7984 18.333 26.1943 18.333 26.6665C18.333 27.1387 18.1733 27.5346 17.8538 27.854C17.5344 28.1734 17.1386 28.3332 16.6663 28.3332H11.6663ZM14.9997 21.6665C14.5275 21.6665 14.1316 21.5068 13.8122 21.1873C13.4927 20.8679 13.333 20.4721 13.333 19.9998C13.333 19.5276 13.4927 19.1318 13.8122 18.8123C14.1316 18.4929 14.5275 18.3332 14.9997 18.3332H24.9997C25.4719 18.3332 25.8677 18.4929 26.1872 18.8123C26.5066 19.1318 26.6663 19.5276 26.6663 19.9998C26.6663 20.4721 26.5066 20.8679 26.1872 21.1873C25.8677 21.5068 25.4719 21.6665 24.9997 21.6665H14.9997ZM23.333 28.3332C22.8608 28.3332 22.465 28.1734 22.1455 27.854C21.8261 27.5346 21.6663 27.1387 21.6663 26.6665C21.6663 26.1943 21.8261 25.7984 22.1455 25.479C22.465 25.1596 22.8608 24.9998 23.333 24.9998H28.333C29.7219 24.9998 30.9025 24.5137 31.8747 23.5415C32.8469 22.5693 33.333 21.3887 33.333 19.9998C33.333 18.6109 32.8469 17.4304 31.8747 16.4582C30.9025 15.4859 29.7219 14.9998 28.333 14.9998H23.333C22.8608 14.9998 22.465 14.8401 22.1455 14.5207C21.8261 14.2012 21.6663 13.8054 21.6663 13.3332C21.6663 12.8609 21.8261 12.4651 22.1455 12.1457C22.465 11.8262 22.8608 11.6665 23.333 11.6665H28.333C30.6386 11.6665 32.6038 12.479 34.2288 14.104C35.8538 15.729 36.6663 17.6943 36.6663 19.9998C36.6663 22.3054 35.8538 24.2707 34.2288 25.8957C32.6038 27.5207 30.6386 28.3332 28.333 28.3332H23.333Z"
          fill="#0088FF"
        />
      </svg>
    ),
    title: "ERP/API Integrations",
    description:
      "Seamless integration with existing systems through robust APIs and pre-built connectors.",
    badge: "Integration",
  },
];

export default function Features() {
  const sectionRef = useRef(null);
  const containerRef = useRef(null);
  const cardsRef = useRef([]);

  const [isSwipe, setIsSwipe] = useState(false);

  useEffect(() => {
    const check = () => setIsSwipe(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const cards = cardsRef.current.filter(Boolean);
      if (!cards.length) return;

      ScrollTrigger.getAll().forEach((t) => t.kill());
      Draggable.get(containerRef.current)?.kill();

      /* ================= MOBILE ================= */
      if (isSwipe) {
        let index = 0;
        let startX = 0;
        const cardHeight = 225;

        // set container height just enough for one card + small padding
        containerRef.current.style.height = `${cardHeight + 40}px`;

        gsap.set(cards, {
          position: "absolute",
          left: "50%",
          top: "50%",
          xPercent: -50,
          yPercent: -50,
          opacity: 0,
          scale: 0.92,
        });

        const render = () => {
          cards.forEach((card, i) => {
            gsap.to(card, {
              xPercent: (i - index) * 110 - 50,
              opacity: i === index ? 1 : 0.25,
              scale: i === index ? 1 : 0.92,
              zIndex: i === index ? 10 : 1,
              duration: 0.25,
              ease: "power2.out",
            });
          });
          setActiveIndex(index);
        };

        render();

        containerRef.current.addEventListener(
          "touchstart",
          (e) => {
            startX = e.touches[0].clientX;
          },
          { passive: true }
        );

        containerRef.current.addEventListener(
          "touchend",
          (e) => {
            const endX = e.changedTouches[0].clientX;
            const delta = endX - startX;

            if (Math.abs(delta) > 40) {
              if (delta < 0 && index < cards.length - 1) index++;
              if (delta > 0 && index > 0) index--;
              render();
            }
          },
          { passive: true }
        );

        return;
      }

      /* ================= DESKTOP / TABLET ================= */
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 10",
          end: "+=2500",
          scrub: 1,
          pin: true,
        },
      });

      const getColumns = () => {
        if (window.innerWidth >= 1280) return 4;
        if (window.innerWidth >= 768) return 2; // tablets get 2 columns
        return 1;
      };

      const cols = getColumns();
      const gap = 20;
      const cardHeight = 225;
      const rowGap = 100;

      // dynamically set container height based on number of rows
      const rows = Math.ceil(cards.length / cols);
      containerRef.current.style.height = `${rows * (cardHeight + rowGap)}px`;

      gsap.set(cards, {
        opacity: 0,
        scale: 0.8,
        x: window.innerWidth + 200,
      });

      cards.forEach((card, i) => {
        const col = i % cols;
        const row = Math.floor(i / cols);

        tl.to(
          card,
          {
            x:
              col * (card.offsetWidth + gap) -
              ((cols - 1) * (card.offsetWidth + gap)) / 2,
            y: row * (cardHeight + rowGap),
            opacity: 1,
            scale: 1,
            ease: "power3.out",
          },
          i * 0.15
        );
      });
    }, sectionRef);

    return () => ctx.revert();
  }, [isSwipe, features]);

  return (
    <section
      ref={sectionRef}
      className="pt-16 pb-20 sm:pt-24 sm:pb-32"
      style={
        isSwipe
          ? {
              backgroundImage: `url(${Vector})`,
              backgroundRepeat: "repeat",
              backgroundSize: "contain",
            }
          : {}
      }
    >
      {!isSwipe && (
        <img
          src={Vector}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />
      )}

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="flex justify-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#EAF3FF] text-[#0A66FF] font-medium px-4 py-1 rounded-full text-sm">
            <HiOutlineDocumentText className="w-5 h-5 text-[#0A66FF]" />
            <span>Core-Competencies</span>
          </div>
        </div>
        <div className="text-center mb-24">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Everything You Need for{" "}
            <span className="bg-gradient-to-r from-[#0088FF] to-[#6583BA] bg-clip-text text-transparent">
              Smart Sourcing
            </span>
          </h2>
          <p className="text-gray-600 text-base sm:text-lg md:text-xl max-w-3xl mx-auto">
            Our platform combines AI, automation, and intelligence to transform
            supplier management.
          </p>
        </div>

        <div
          ref={containerRef}
          className="
    relative
    h-[360px]
    sm:h-[900px]
    lg:h-[700px]
    flex
    justify-center
  "
        >
          {features.map((f, i) => (
            <div
              key={i}
              ref={(el) => (cardsRef.current[i] = el)}
              className="
                absolute w-[90%] sm:w-[320px] h-[225px]
                bg-white border border-gray-200
                rounded-xl p-6 shadow-lg
                transition-all
                sm:hover:shadow-2xl sm:hover:scale-[1.07]
              "
            >
              <div className="flex justify-between mb-4">
                {f.icon}
                <span
                  className={`bg-[#EAF5241A]/15 text-base px-4 py-2 rounded-full whitespace-nowrap ml-2`}
                >
                  {f.badge}
                </span>
              </div>
              <h3 className="font-medium text-lg mb-3">{f.title}</h3>
              <p className="text-gray-600">{f.description}</p>
            </div>
          ))}
        </div>

        {isSwipe && (
          <div className="flex justify-center gap-2 mt-10">
            {features.map((_, i) => (
              <span
                key={i}
                className={`h-2 rounded-full transition-all ${
                  i === activeIndex ? "bg-[#0088FF] w-6" : "bg-gray-300 w-2"
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
